import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate } from '@angular/router';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class B2CLoginEnabledGuard implements CanActivate {
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  async canActivate(): Promise<boolean> {
    if (this.isBrowser) {
      if (environment.isB2CLoginEnabled) {
        window.location.href = environment.loginRedirectUrl;

        return false;
      }
    }
    return true;
  }
}
